import { FC, memo } from 'react';
import classNames from 'classnames';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import IconRenderer from '@zvuk-b2b/react-uikit/ui/icons/IconRenderer';

import useSberIDReauth from '../../model/useSberIDReauth';
import { TEXTS } from '../../model/texts';
import icon from './sber_id_logo_small.svg';

import styles from './SberIDReauth.module.scss';

const SberIDReauth: FC = () => {
  const { sberIdButtonDisabled, handleReauth } = useSberIDReauth();

  return (
    <div className={styles.container}>
      <Button
        elementId="button_sber_business_online_reauth"
        className={styles.sberIdButton}
        type={ButtonType.PLAIN}
        isLoading={false}
        isDisabled={sberIdButtonDisabled}
        onClick={handleReauth}>
        <IconRenderer
          iconHtml={icon}
          className={classNames(styles.icon, {
            [styles.iconDisabled]: sberIdButtonDisabled,
          })}
        />
        {sberIdButtonDisabled ? TEXTS.SBER_ID_DISABLED_TEXT : TEXTS.SBER_ID_TEXT}
      </Button>
      <div className={styles.hint}>{TEXTS.SBER_ID_HINT}</div>
    </div>
  );
};

export default memo(SberIDReauth);
